//    Product page tracking script
//   This snippet handles the tracking of source information and cart attributes on product pages
 
 document.addEventListener('DOMContentLoaded', function() {
      console.log('Debug - Product Page Load - URL Params:', window.location.search);
      
      try {
          console.log('Debug - Product Page Load - Session Storage:', {
              sourceId: sessionStorage.getItem('sourceIdentifier'),
              sourceDesc: sessionStorage.getItem('sourceDescription'),
              referrer: sessionStorage.getItem('registeredSourceUrl'),
              allStorage: Object.fromEntries(Object.keys(sessionStorage).map(key => [key, sessionStorage.getItem(key)]))
          });
      } catch (e) {
          console.error('Debug - Error accessing session storage:', e);
      }

      // Instead of adding a click handler, we'll modify the form before submission
      const productForm = document.querySelector('form[action="/cart/add"]');
      if (productForm) {
          const urlParams = new URLSearchParams(window.location.search);
          let sourceId = urlParams.get('source_identifier') || sessionStorage.getItem('sourceIdentifier');
          let shipName = urlParams.get('shipname') || sessionStorage.getItem('shipName');
          let sourceDesc = sessionStorage.getItem('sourceDescription');
          let referrerUrl = sessionStorage.getItem('registeredSourceUrl');

          // Add hidden fields to form
          if (sourceId) {
              const cartData = {
                  'sourceIdentifier': sourceId,
                  'sourceDescription': sourceDesc || `Globe View - ${shipName}`,
                  'registeredSourceUrl': referrerUrl || document.referrer
              };

              // Add hidden fields
              Object.entries(cartData).forEach(([key, value]) => {
                  let input = productForm.querySelector(`input[name="attributes[${key}]"]`);
                  if (!input) {
                      input = document.createElement('input');
                      input.type = 'hidden';
                      input.name = `attributes[${key}]`;
                      productForm.appendChild(input);
                  }
                  input.value = value;
              });
          }
      }
  });